module.exports = __webpack_public_path__ + "static/img/Hotel-Railway-Brunswick.340e83d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Hotel-Railway-Brunswick.jpg
// module id = JRt1
// module chunks = 0